import React from 'react';
import { Menu, X, LogOut } from 'lucide-react';
import { Button, Avatar, Menu as MantineMenu, Text, Badge } from '@mantine/core';
import { signInWithGoogle, logOut } from '../firebase';
import { Logo } from './Logo';
export const Header = ({
  sidebarOpen,
  setSidebarOpen,
  user,
  apiKeySet
}) => {
  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in failed:', error);
    }
  };
  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };
  return <header className="bg-white border-b border-gray-200 py-2 sm:py-3 px-2 sm:px-4 flex items-center justify-between" data-id="element-135">
      <div className="flex items-center" data-id="element-136">
        <Button variant="subtle" className="mr-2 sm:mr-4 md:hidden p-1" onClick={() => setSidebarOpen(!sidebarOpen)} data-id="element-137">
          {sidebarOpen ? <X size={18} data-id="element-138" /> : <Menu size={18} data-id="element-139" />}
        </Button>
        <Logo data-id="element-140" />
      </div>
      <div className="flex items-center" data-id="element-141">
        <Button variant="light" className="mr-1 sm:mr-2 text-xs p-1 sm:p-2 h-7 sm:h-auto" size="xs" styles={{
        root: {
          fontSize: '12px'
        }
      }} data-id="element-142">
          Help
        </Button>
        {user ? <MantineMenu shadow="md" width={200} data-id="element-143">
            <MantineMenu.Target data-id="element-144">
              <Button variant="subtle" className="flex items-center p-1 h-8" data-id="element-145">
                <Avatar src={user.photoURL} alt={user.displayName} radius="xl" size="sm" className="mr-0 sm:mr-2" data-id="element-146" />
                <Text size="xs" fw={500} className="hidden sm:block" data-id="element-147">
                  {user.displayName}
                </Text>
              </Button>
            </MantineMenu.Target>
            <MantineMenu.Dropdown data-id="element-148">
              <MantineMenu.Label data-id="element-149">Account</MantineMenu.Label>
              <MantineMenu.Item data-id="element-150">Profile</MantineMenu.Item>
              <MantineMenu.Divider data-id="element-151" />
              <MantineMenu.Item leftSection={<LogOut size={14} data-id="element-153" />} onClick={handleSignOut} color="red" data-id="element-152">
                Sign out
              </MantineMenu.Item>
            </MantineMenu.Dropdown>
          </MantineMenu> : <Button variant="filled" className="bg-blue-600 text-xs sm:text-sm p-1 sm:p-2 h-7 sm:h-auto" onClick={handleSignIn} size="xs" styles={{
        root: {
          fontSize: '12px'
        }
      }} data-id="element-154">
            Sign In
          </Button>}
      </div>
    </header>;
};